<template>
  <v-dialog
    max-width="800"
    :value="value"
    persistent
    :fullscreen="$vuetify.breakpoint.smAndDown"
    @keydown.esc="close(selectedItem)"
  >
    <v-card tile v-if="value">
      <v-app-bar dark flat color="primary">
        <v-btn icon dark @click="close(selectedItem)">
          <v-icon>close</v-icon>
        </v-btn>
        <span class="title">{{
          value.selectedItem
            ? resx.labels.updateObligations
            : resx.labels.newObligations
        }}</span>
      </v-app-bar>
      <form @submit.prevent="save()" novalidate>
        <v-card-text>
          <v-container grid-list-xl>
            <v-row wrap>
              <v-col cols="12" md="6">
                <v-text-field
                  data-vv-name="name"
                  :data-vv-as="resx.labels.name"
                  :label="resx.labels.name"
                  :error-messages="errors.collect('name')"
                  v-model="selectedItem.name"
                  v-validate="'required'"
                  required
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-select
                  data-vv-name="type"
                  :data-vv-as="resx.labels.obligationType"
                  :label="resx.labels.obligationType"
                  :error-messages="errors.collect('type')"
                  v-model="selectedItem.type"
                  v-validate="'required'"
                  item-text="text"
                  item-value="id"
                  :items="obligationTypes"
                  single-line
                  :no-data-text="resx.messages.noSelectorDataAvailable"
                  :disabled="obligationTypes.length === 0"
                >
                </v-select>
              </v-col>
              <v-col
                xs12
                sm12
                v-bind:md6="selectedItem.dueDateType == 'monthly'"
              >
                <v-select
                  data-vv-name="dueDateType"
                  :data-vv-as="resx.labels.dueDateType"
                  :label="resx.labels.dueDateType"
                  :error-messages="errors.collect('dueDateType')"
                  v-model="selectedItem.dueDateType"
                  v-validate="'required'"
                  :items="dueDateTypes"
                  item-text="text"
                  item-value="id"
                  single-line
                  :no-data-text="resx.messages.noSelectorDataAvailable"
                  :disabled="dueDateTypes.length === 0"
                >
                </v-select>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-if="selectedItem.dueDateType == 'monthly'"
                  v-model="selectedItem.dayOfMonth"
                  :label="resx.labels.dayOfMonth"
                  :data-vv-as="resx.labels.dayOfMonth"
                  data-vv-name="dayOfMonth"
                  :error-messages="errors.collect('dayOfMonth')"
                  v-validate="'required|between:1,31'"
                  type="number"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12">
                <v-autocomplete
                  v-model="selectedItem.tags"
                  :items="tags"
                  item-text="name"
                  item-value="_id"
                  :label="resx.labels.tags"
                  multiple
                  chips
                  deletable-chips
                >
                </v-autocomplete>
                <!-- Sin esta aclaracion, cualquiera supondria que editar las
                     etiquetas de la maestra reetiqueta lo ya cargado. -->
                <div v-if="!adhoc" class="body-2 grey--text">
                  Se asignan a las obligaciones nuevas que se generen de esta
                  clase. Editarlas acá no modifica las obligaciones que los
                  contratistas ya tienen cargadas.
                </div>
              </v-col>
              <v-col cols="12" class="input-comment">
                <comments-component
                  v-model="selectedItem.comments"
                  mode="edit"
                  :label="resx.labels.comments"
                  @input="selectedItem.comments = $event"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="close(selectedItem)">{{ resx.labels.cancel }}</v-btn>
          <v-btn class="primary" type="submit" :disabled="!isValidForm">{{
            resx.labels.ok
          }}</v-btn>
        </v-card-actions>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
"use strict";

import obligationService from "@/services/ObligationService";
import tagsService from "@/services/TagsService";
import { sprintf } from "sprintf-js";
import commentsComponent from "@/components/common/comments.vue";

export default {
  name: "edit-obligation",
  async mounted() {
    this.obligationTypes = await obligationService.getObligationTypes();
    this.dueDateTypes = await obligationService.getDueDateTypes();
    this.tags = await tagsService.list();

    this.obligationTypes = this.obligationTypes.map(t => {
      return { id: t, text: this.$store.state.locale.resx.labels[t] };
    });
    this.dueDateTypes = this.dueDateTypes.map(t => {
      return { id: t, text: this.$store.state.locale.resx.labels[t] };
    });
    if (this.adhoc && this.adhoc.obligations) {
      this.obligationTypes = this.obligationTypes.filter(
        o => this.adhoc.obligations.indexOf(o.text) > -1
      );
    }
  },
  components: {
    commentsComponent
  },
  data() {
    return {
      menu: false,
      obligationTypes: [],
      dueDateTypes: [],
      tags: [],
      datePicked: null,
      selectedItem: null,
      originalSelectedItem: null,
      obligation: null
    };
  },
  methods: {
    async save() {
      let result = null;
      let payload = Object.assign({}, this.selectedItem);
      if (this.adhoc) {
        payload.adhoc = true;
      }
      if (!this.value.selectedItem) {
        result = this.adhoc ? payload : await obligationService.create(payload);
        this.$emit("save", { isNew: true, item: result });
      } else {
        result = this.adhoc ? payload : await obligationService.edit(payload);
        this.$emit("save", { isNew: false, item: result });
      }
    },
    async close(obligation) {
      if (JSON.stringify(this.originalSelectedItem) != JSON.stringify(this.selectedItem)) {
        await this.botConfirmDialog({
          title: `${
          this.resx.labels.edit
          } ${this.resx.labels.obligation.toLowerCase()}`,
          content: sprintf(
          this.resx.messages.noSavedChanges,
          obligation.name
          )
        })
        this.$emit("close");
      } else {
        this.$emit("close");
      }
    }
  },
  props: ["value", "adhoc"],
  watch: {
    value(val) {
      this.selectedItem =
        val && val.selectedItem ? Object.assign({}, val.selectedItem) : {};
      // Las etiquetas pueden llegar como ids o como objetos segun si el
      // backend populo. El v-autocomplete trabaja con ids.
      this.selectedItem.tags = (this.selectedItem.tags || []).map(t =>
        typeof t === "string" ? t : t._id
      );
      this.originalSelectedItem = Object.assign({}, this.selectedItem);
    }
  }
}

</script>
